var win;

if (typeof window !== "undefined") {
    win = window;
} else if (typeof global !== "undefined") {
    win = global;
} else if (typeof self !== "undefined"){
    win = self;
} else {
    win = {};
}

module.exports = win;



//////////////////
// WEBPACK FOOTER
// /Users/hynek/Work/localhost/malcom/wp-content/themes/malcom/node_modules/videojs7-vimeo/node_modules/videojs-vtt.js/node_modules/global/window.js
// module id = 135
// module chunks = 0